import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CDFlorderType } from '../../../core/store/contract-details/contract-details.interface';
import { Definitions } from '../../../core/store/definitions/definitions.interface';
import { DeliveryMethod } from '../../../core/store/edit-florder-detail/florder-detail.interface';
import { PanelStatus } from '../../florder/florder-edit-container/florder-edit.interface';
import { Definition } from '../../../core/store/definitions/definition.interface';
import { util } from '../../../core/util/util';
import { appSettings } from '../../../appSettings';
import { LayoutBreakpoints } from '../../../core/util/layout-breakpoints';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Destroyable } from '@dlw-int-mwi/eps-common';

@Component({
  selector: 'app-ccr-edit-delivery',
  templateUrl: './ccr-edit-delivery.component.html',
  styleUrls: ['../../florder/florder-edit-delivery/florder-edit-delivery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CCREditDeliveryComponent extends Destroyable implements OnChanges {
  @Input() orderTypes: CDFlorderType[];
  @Input() ccrForm: UntypedFormGroup;
  @Input() deliveryMethod: DeliveryMethod;
  @Input() panelStatus: PanelStatus;
  @Input() definitions: Definitions;
  labelWidth = appSettings.LABEL_WIDTH;

  resolutionOkForArrow = true;

  constructor(private translate: TranslateService, private cd: ChangeDetectorRef, breakpointObserver: BreakpointObserver) {
    super();
    LayoutBreakpoints
      .matches(breakpointObserver, LayoutBreakpoints.bootstrapSmOrMore)
      .pipe(this.takeUntilDestroyed())
      .subscribe(resolutionOkForArrow => {
        this.resolutionOkForArrow = resolutionOkForArrow;
        cd.markForCheck();
      });
  }

  ngOnChanges() {
    this.cd.detectChanges();
  }

  getName(definitions: Definition[], id: string): string {
    return util.getDefinitionName(definitions, id);
  }

  showFrom() {
    return this.ccrForm.value.type !== 'EPS-CUS' || this.ccrForm.value.shippingCondition?.id !== 'Z1';
  }
  showTo() {
    return this.ccrForm.value.type !== 'CUS-EPS' || this.ccrForm.value.shippingCondition?.id !== 'Z1';
  }
}
